import React, { Suspense } from "react";
import { CircularProgress } from "@material-ui/core";
import LoadingOverlay from "react-loading-overlay";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { Link } from "react-router-dom";
import IntlMessages from "util/IntlMessages";
import OSCOHTLogo from "../assets/images/OSCOHT-LOGO.jpg";
import { NotificationContainer, NotificationManager } from "react-notifications";
import { fetchJSON } from "helpers/axios";

class ConfirmNewPassword extends React.Component {
  constructor() {
    super();
    this.state = {
      loader: false,
      code: "",
      userMode: "",
      step: "",
      password1: "",
      password2: "",
      passwordFinal: "",
    };
  }

  componentDidMount() {
    const code = this.getURLParameter("id");
    const mode = this.getURLParameter("usermode");
    if (this.props.userMode == "" || code == null || mode == null) {
      this.props.history.push("/");
    } else {
      if (this.props.userMode == "Staff") {
        this.setState({
          userMode: "Admin",
        });
      } else {
        this.setState({
          userMode: mode,
        });
      }
    }
  }

  getURLParameter = (sParam) => {
    const sPageURL = window.location.search.substring(1);
    let sURLVariables = sPageURL.split("&");
    for (let i = 0; i < sURLVariables.length; i++) {
      let sParameterName = sURLVariables[i].split("=");
      if (sParameterName[0] == sParam) {
        return decodeURIComponent(sParameterName[1]);
      }
    }
  };

  getResetCode = (e) => {
    const id = {};
    let parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
      id[key] = value;
    });
    return id;
  };

  validatePassword = (e) => {
    //  const strongRegex = new RegExp("^(?=.{8,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*\\W).*$", "g");
    // const strongRegex = new RegExp("^(?=.{8,})(((?=.*[A-Z])(?=.*[a-z]))|((?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9]))).*$", "g");
    const enoughRegex = new RegExp("(?=.{8,}).*", "g");
    //check empty password
    if (e == "") {
      NotificationManager.error("Password Field is Empty");
      return false;
    }
    if (false == enoughRegex.test(e)) {
      NotificationManager.error("Password should contain 8 - 15 characters, Symbols, Numbers, Upper and Lower Case Letters ");
      return false;
    } else {
      return true;
    }
  };

  passwordsMatch = (pass1, pass2) => {
    if (pass1 == pass2) {
      return true;
    } else {
      NotificationManager.error("Passwords Do Not match");
      /* (pass1);
      (pass2); */
      return false;
    }
  };

  submitNewPassword = async () => {
    try {
      //check if password is accepted
      this.setState({ loader: true });
      // (this.state.password1);
      this.passwordsMatch(this.state.password1, this.state.password2);
      let code = this.getURLParameter("id");
      let userMode = this.getURLParameter("usermode");

      let model = {};
      let password = this.state.password1;
      if (password == "") {
        this.setState({ loader: false, passwordFinal: "" });
        NotificationManager.error("Password is required");
        return false;
      } else if (!this.validatePassword(password)) {
        this.setState({
          loader: false,
          password1: "",
          password2: "",
          passwordFinal: "",
        });
        NotificationManager.warning("Password Does Not Meet Requirements");
        return false;
      } else {
        model = {
          code: code,
          userMode: userMode,
          step: 2,
          password: password,
        };
        //(model);
      }

      //submit new password
      // this.setState({ loader: true });
      const response = await fetchJSON("api/Account/ForgotPassword", model, "POST");
      if (response.Status == "Ok") {
        // (response);
        this.setState({
          loader: false,
          password1: "",
          password2: "",
          passwordFinal: "",
        });
        NotificationManager.success(response.Message, "Success");
        if (userMode == "Staff") {
          this.props.history.push(`/AdminSignin`);
        } else {
          this.props.history.push(`/${userMode}Signin`);
        }
      } else if (response.Status == "NotFound") {
        
        this.setState({
          loader: false,
          password1: "",
          password2: "",
          passwordFinal: "",
        });
        NotificationManager.error(response.Message);
      } else if (response.Status == "Error") {
        NotificationManager.error(response.Message);
        this.setState({
          loader: false,
          password1: "",
          password2: "",
          passwordFinal: "",
        });
       
      } else {
        this.setState({
          loader: false,
          password1: "",
          password2: "",
          passwordFinal: "",
        });
        
      }
    } catch (e) {
   
    }
  };

  render() {
    const { width } = this.props;
    const { loader, userMode } = this.state;
    return (
      <div className="container">
        <div className="row login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
          <div className="col-md-4 login-content">
            <Suspense
              fallback={
                <div
                  className="loader-view"
                  style={{
                    height: width >= 1200 ? "calc(100vh - 265px)" : "calc(100vh - 245px)",
                  }}
                >
                  <CircularProgress />
                </div>
              }
            >
              <LoadingOverlay active={loader} spinner text="Loading...">
                <div className="login-header">
                  <Link className="app-logo" to="/" title="Jambo">
                    <img src={OSCOHTLogo} alt="OSCOHTLogo" title="OSCOHTLogo" />
                  </Link>
                </div>

                <div className="mb-2">
                  <h2>
                    <IntlMessages id="Enter New Password" />
                  </h2>
                </div>

                <div className="login-form">
                  <form method="post" action="/">
                    <TextField
                      type="password"
                      // id="required"
                      id="password1"
                      label={<IntlMessages id="appModule.password" />}
                      fullWidth
                      value={this.state.password1}
                      // {this.password1Handler}
                      onChange={(event) => this.setState({ password1: event.target.value })}
                      margin="normal"
                      className="mt-0 mb-4"
                    />

                    <TextField
                      type="password"
                      // id="required"
                      id="password2"
                      label={<IntlMessages id="Confirm Password" />}
                      fullWidth
                      value={this.state.password2}
                      //{this.password2Handler}
                      onChange={(event) => this.setState({ password2: event.target.value })}
                      margin="normal"
                      className="mt-0 mb-4"
                    />

                    {/* <p className="mb-3">
                    <IntlMessages id="appModule.dntRememberEmail" /> &nbsp;
                    <span className="small jr-link">
                      <IntlMessages id="appModule.signIn" />
                    </span>
                  </p> */}
                    <div className="mb-3 d-flex align-items-center justify-content-between">
                      <Button onClick={this.submitNewPassword} variant="contained" color="primary" className="text-white">
                        <IntlMessages id="appModule.resetPassword" />
                      </Button>

                      <Link to={`../${userMode}signIn`}>
                        <IntlMessages id="appModule.signIn" />
                      </Link>
                    </div>
                  </form>
                </div>
              </LoadingOverlay>
            </Suspense>
          </div>
        </div>
        <NotificationContainer />
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { userMode } = auth;
  return { userMode };
};

export default connect(mapStateToProps)(ConfirmNewPassword);
